export function getCookiebotDomainGroupId(): string | undefined {
  const id = process.env.NEXT_PUBLIC_COOKIEBOT_DOMAIN_GROUP_ID;
  if (typeof id !== "string" || id.trim() === "") return undefined;
  return id.trim();
}
